import React, { useRef, useEffect } from 'react';

const AudioVisualizer = ({ stream }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (!stream || stream.getAudioTracks().length === 0) return;

        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const analyser = audioContext.createAnalyser();
        const source = audioContext.createMediaStreamSource(stream);
        source.connect(analyser);

        analyser.fftSize = 256;
        const bufferLength = analyser.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);

        const canvas = canvasRef.current;
        const canvasCtx = canvas.getContext('2d');
        let animationFrameId;

        const draw = () => {
            animationFrameId = requestAnimationFrame(draw);
            analyser.getByteFrequencyData(dataArray);

            canvasCtx.fillStyle = '#1F2937'; // Background color
            canvasCtx.fillRect(0, 0, canvas.width, canvas.height);

            const barWidth = (canvas.width / bufferLength) * 2.5;
            let barHeight;
            let x = 0;

            for (let i = 0; i < bufferLength; i++) {
                barHeight = dataArray[i] / 2;
                canvasCtx.fillStyle = '#3B82F6'; // Bar color
                canvasCtx.fillRect(x, canvas.height - barHeight, barWidth, barHeight);
                x += barWidth + 1;
            }
        };

        draw();

        return () => {
            cancelAnimationFrame(animationFrameId);
            audioContext.close();
        };
    }, [stream]);

    return <canvas ref={canvasRef} width="150" height="40" aria-label="Audio level indicator" />;
};

export default AudioVisualizer;
